import { createSlice } from "@reduxjs/toolkit"

const initialStateFactura = {
  idFactura: '',
  documentos: [],
  files: []
}

export const datosFacturaSlice = createSlice({
  name: "datosFactura",
  initialState: initialStateFactura,
  reducers: {
    setIdFactura: (state, action) => {
      state.idFactura = action.payload
    },
    setDocumentos: (state, action) => {
      state.documentos = action.payload
    },
    addDocumentos: (state, action) => {
      state.documentos = [...state.documentos, action.payload]
    },
    addFiles: (state, action) => {
      state.files = [...state.files, action.payload]
    },
    resetDocumentos: (state) => {
      state.documentos = initialStateFactura.documentos
      state.files = initialStateFactura.files
    },
    resetIdFactura: (state) => {
      state.idFactura = initialStateFactura.idFactura
    }
  }
})

export const { addDocumentos, resetDocumentos, setDocumentos, addFiles, setIdFactura, resetIdFactura } = datosFacturaSlice.actions
export default datosFacturaSlice.reducer
